import { Box, Grid, Paper, useTheme } from "@mui/material";
import { gridClasses, GridColDef } from "@mui/x-data-grid";
import { FC, useMemo } from "react";
import { Link, Outlet } from "react-router-dom";
import { Permissions, Property } from "../../api/dtos";
import GridActions from "../../components/GridActions";
import SetLinks from "../../components/layout/SetLinks";
import { StyledButton } from "../../components/StyledButton";
import CollapsibleTablePremium from "../../components/tables/CollapsibleTablePremium";
import { createCustomToolbarProps } from "../../components/utility/CustomToolbarProps";
import { DefaultProjectCreateLink } from "../../contexts/layouts/LinkContext";
import PropertiesContext from "../../contexts/PropertiesContext";
import useProperties from "../../hooks/data/useProperties";

const usePropertyColumns = () => {

    const agentColumns = useMemo(() => {
        const columns: GridColDef<Property>[] =  [
            {
                field: "name",
                headerName: "Name",
                flex: 1
            },
            {
                field: "rank",
                headerName: "Rank",
                flex: 1
            },
            {
                field: "actions",
                headerName: '',
                renderCell: (params) => {
                    return (
                        <GridActions
                            editPermission={Permissions.AdminAccess}
                            editUrl={`/admin/lot-properties/edit/${params.row.id}`}
                        />
                    )
                },
                disableExport: true
            }
        ];

        return columns;
    }, []);

    return agentColumns;
}


const Properties:FC = () => {

    const columns = usePropertyColumns();

    const theme = useTheme();
    
    const context = useProperties();

    const {data: properties, loading: propertiesLoading} = context;
    
    const customToolbarProps = useMemo(() => createCustomToolbarProps({
        fileName: `Lot Properties`,
        exportTitle: `Lot Properties`,
        includeDateTime: true
    }), []);

    return (
        <PropertiesContext.Provider value={context}>
            <Outlet />
            <SetLinks
                createProjectLink={DefaultProjectCreateLink}
                stageLinkEnabled={false}
                lotLinkEnabled={false}
            />
            <Grid
                container
                gap={theme.spacing(2)}
                justifyContent={"end"}
                marginBottom={theme.spacing(2)}
            >
                <StyledButton 
                        variant="contained"
                        //@ts-expect-error
                        component={Link}
                        to={`/admin/lot-properties/create`}
                        state={{
                            back: true
                        }}
                >
                    Add Property
                </StyledButton>
            </Grid>
            <Paper>
                <Box
                    sx={{
                        [`& .${gridClasses.root}`]: {
                            
                            [`& .${gridClasses.columnHeader}`]: {
                                height: 'auto !important',
                                minHeight: 56,
                                
                                [`& .${gridClasses.columnHeaderTitleContainer}`]: {
                                    whiteSpace: 'normal',
                                    
                                    [`& .${gridClasses.columnHeaderTitle}`]: {
                                        whiteSpace: 'normal',
                                        paddingTop: theme.spacing(1.5),
                                        paddingBottom: theme.spacing(1.5) 
                                    }
                                },
                                
                                [`& .${gridClasses.iconButtonContainer}`]: {
                                    width: 'unset',
                                },
                                
                                '&.column-group-header': {
                                    backgroundColor: theme.palette.grey[300],
                                    boxShadow: "1",
                                    textAlign: 'center'
                                }
                            }
                        },
                    }}
                    >
                    <CollapsibleTablePremium
                        density="compact"
                        startCollapsed={false} 
                        title={"Properties"} 
                        loading={propertiesLoading} 
                        columns={columns}
                        rows={properties}
                        disableColumnMenu={false}
                        disableColumnFilter={false}
                        {...customToolbarProps}
                    />
                </Box>
            </Paper>
        </PropertiesContext.Provider>
    );
}

export default Properties;